import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { userStorageUseCase } from 'application/usecases/UserStorageUseCase';
import { User } from 'domain/entities/UserEntity';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';

export type UserAuthen = {
    user: User;
    grantPoint?: number;
    token: string;
    refreshToken: string;
};

interface AuthenSlice {
    user: UserAuthen | null;
    implementerClassification?: number;
    isSignedIn: boolean;
}

const initialState: AuthenSlice = {
    user: null,
    isSignedIn: false,
};

export const userSlice = createSlice({
    name: 'authenSlice',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            state.isSignedIn = true;
        },
        setHeaderInfo: (state, action) => {
            if (state.user === null) return;
            if (action.payload === null) {
                state.implementerClassification = BUYER_CLASSIFICATION;
                state.user.grantPoint = 0;
                return;
            } else {
                state.implementerClassification = action.payload.implementerClassification;
                state.user.grantPoint = action.payload.grantPoint;
                return;
            }
        },
        setGrantPoint: (state, action: PayloadAction<number | undefined>) => {
            if (state.user === null) return;
            if (action.payload === null) {
                state.user.grantPoint = 0;
                return;
            } else {
                state.user.grantPoint = action.payload;
                return;
            }
        },
        changeImplementerClassification: (state, action) => {
            if (action.payload === null) {
                state.implementerClassification = BUYER_CLASSIFICATION;
                return;
            } else {
                state.implementerClassification = action.payload;
                return;
            }
        },
        logout: () => {
            userStorageUseCase.removeUserInfo();
            return initialState;
        },
    },
});

export const { setUser, logout, setHeaderInfo, changeImplementerClassification, setGrantPoint } =
    userSlice.actions;
export default userSlice.reducer;
